import { render, staticRenderFns } from "./UserInfoCard.vue?vue&type=template&id=992ec3e6&scoped=true&"
import script from "./UserInfoCard.vue?vue&type=script&lang=js&"
export * from "./UserInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "992ec3e6",
  null
  
)

export default component.exports